import { App } from './app';
import { getMessaging } from 'firebase/messaging/sw'; 

export const messaging = getMessaging(App);